import { render, staticRenderFns } from "./SettingsStepsForm.vue?vue&type=template&id=ec20e9c4&scoped=true"
import script from "./SettingsStepsForm.vue?vue&type=script&lang=js"
export * from "./SettingsStepsForm.vue?vue&type=script&lang=js"
import style0 from "./SettingsStepsForm.vue?vue&type=style&index=0&id=ec20e9c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec20e9c4",
  null
  
)

export default component.exports